import React, { useState } from "react";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { Button, Card, Collapse, GridLegacy, Typography } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../../components/TranslationWrapper/TranslationWrapper";
import FormControlledInputTC from "../../../../components/Forms/FormControlledInputTC";
import AsynchronousAutocomplete from "../../../../components/Autocomplete/AsynchronousAutocomplete";
import { makeid } from "./Fonts/CustomFonts";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import CardBody from "../../../../components/Card/CardBody";

export default function ArticlegroupsShortcutPage() {
  const { register, vestigingId, menukaartVestigingId, reloadDataFromServer } = useFormContext();
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    name: "custom_data.articlegroups_shortcut_page.articlegroup_settings",
  });

  const enabled = useWatch({ name: "custom_data.articlegroups_shortcut_page.enabled" });

  return (
    <Card>
      <CardBody>
        <GridLegacy container spacing={1} style={{ fontSize: "0.875rem" }}>
          <GridLegacy item xs={12}>
            <h3>
              <TranslationWrapper
                tDefault={"Articlegroups Shortcut FrontPage"}
                tKey={"vestigingen.form.algemeen.headers.articlegroupsshortcutfrontPage"}
              />
            </h3>
          </GridLegacy>
          <FormSwitchTC
            name={"custom_data.articlegroups_shortcut_page.enabled"}
            tDefault={"Enabled"}
            tKey={"custom_data.articlegroups_shortcut_page.enabled.enabled"}
          />
          <Collapse in={enabled}>
            <FormControlledInputTC
              name={"custom_data.articlegroups_shortcut_page.enabled.number_of_columns"}
              rules={{
                max: { value: 12, message: getTranslation("The maximum value is 12!") },
                min: { value: 1, message: getTranslation("The minimum value is 1!") },
              }}
              tDefault={"Number of columns"}
              tKey={"custom_data.articlegroups_shortcut_page.enabled.number_of_columns"}
              type={"number"}
            />
            {fields.map((field, index) => {
              return (
                <GridLegacy container style={{ backgroundColor: "#00000011" }}>
                  <GridLegacy item xs={6}>
                    Articlegroup #{index + 1}
                  </GridLegacy>
                  <GridLegacy item xs={6}>
                    <Typography>{field.label}</Typography>
                  </GridLegacy>
                  <GridLegacy item xs={6}>
                    Image
                  </GridLegacy>
                  <GridLegacy item xs={6}>
                    <input
                      key={field.id}
                      placeholder={"Image"}
                      type={"file"}
                      {...register(`articlegroups_shortcut_page_articlegroup_settings.${index}.image`)}
                    />
                  </GridLegacy>

                  <Button
                    onClick={(e) => {
                      remove(index);
                    }}
                  >
                    Remove
                  </Button>
                </GridLegacy>
              );
            })}

            <AddNewArticlegroup append={append} />
          </Collapse>
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

function AddNewArticlegroup({ append }) {
  const { register, vestigingId, menukaartVestigingId, reloadDataFromServer } = useFormContext();
  const [articlegroup, setArticlegroup] = useState(null);
  return (
    <>
      <AsynchronousAutocomplete
        async={{
          url: `core/kaarten/search?fields=id as value,naam as label,vestiging_id,apiId1&sort_field=naam&sort_dir=asc&vestiging_id=${menukaartVestigingId}`,
          searchField: "naam",
          perPage: 20,
          // extraFilters: { vestiging_id: { name: "vestiging_id", value: "vestiging_id" } },
        }}
        getOptionLabel={(option) => {
          return option.label + " - " + option.value;
        }}
        key={menukaartVestigingId}
        onChange={(e, option) => {
          setArticlegroup(option);
          // if (option) {
          //     setArticlegroup(option);
          //   props.setFilter("menukaart.id", {
          //     field: "menukaart.id",
          //     operator: "=",
          //     value: option.value,
          //     label: option.label,
          //     vestiging_id: option.vestiging_id,
          //   });
          // } else {
          //   props.setFilter("menukaart.id", null);
          // }
        }}
        placeholder={getTranslation("Find one")}
        value={articlegroup}
      />
      <Button
        disabled={!articlegroup}
        onClick={() => {
          let uuid = "";
          if (window.crypto?.randomUUID) {
            uuid = window.crypto.randomUUID();
          } else {
            uuid = makeid(32);
          }
          setArticlegroup(null);
          append({ id: uuid, ...articlegroup });
        }}
      >
        Add articlegroup
      </Button>
    </>
  );
}
